import React from "react";
import Form from "react-bootstrap/Form";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button, Modal } from "@mui/material";

import useStyles from "../DashboardAuction/dashAuction.style";

const SellerProfileModal = ({
  open,
  handleClose,
  handleSubmitSeller,
  handleChangeSeller,
  editProfile,
  companyName,
  businessType,
  bi_tin_ein,
  streetOne,
  streetTwo,
  city,
  postalCode,
  country,
  state,
  firstName,
  lastName,
  title,
  contactNumber,
  alternateContactNumber,
  email,
  countriesList,
  stateList,
  setEditProfile,
  errors,
  auctionGracePeriodHours, // FIX 4: New prop
}) => {
  const classes = useStyles();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 1200,
    maxHeight: "90vh",
    bgcolor: "background.paper",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    borderRadius: "12px",
    p: 4,
    overflow: "auto",
  };

  const sectionStyle = {
    marginBottom: "2rem",
    padding: "1.5rem",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  };

  const inputStyle = {
    marginBottom: "1rem",
  };

  const labelStyle = {
    fontWeight: "600",
    color: "#495057",
    marginBottom: "0.5rem",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modalMain"
    >
      <Box sx={style} className="modalMain">
        <Typography
          className={classes.headText}
          sx={{
            fontSize: "24px !important",
            marginBottom: "2rem",
            textAlign: "center",
            color: "#2c3e50",
          }}
        >
          Auctioneer Profile Details
        </Typography>

        <form onSubmit={handleSubmitSeller}>
          <div className={classes.forms}>
            {/* Company Information Section */}
            <Box sx={sectionStyle}>
              <Typography
                className={classes.headText}
                sx={{
                  fontSize: "18px !important",
                  marginBottom: "1.5rem",
                  color: "#34495e",
                  borderBottom: "2px solid #3498db",
                  paddingBottom: "0.5rem",
                }}
              >
                Company Information
              </Typography>

              <div className="row">
                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Company Name *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="companyName"
                        placeholder="Enter Company Name"
                        required
                        disabled={!editProfile}
                        value={companyName || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Business Type *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="businessType"
                        placeholder="Enter Business Type"
                        required
                        disabled={!editProfile}
                        value={businessType || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Business Identification Number (BI/TIN/EIN) *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="bi_tin_ein"
                        placeholder="Enter Business ID Number"
                        required
                        disabled={!editProfile}
                        value={bi_tin_ein || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Auction Grace Period (Hours)
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="number"
                        name="auctionGracePeriodHours"
                        placeholder="Enter hours (0-168)"
                        min="0"
                        max="168"
                        disabled={!editProfile}
                        value={auctionGracePeriodHours ?? ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                      <Form.Text className="text-muted">
                        Number of hours after auction completion before it gets
                        finalized (Max: 168 hours/7 days)
                      </Form.Text>
                      {errors.auctionGracePeriodHours && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {errors.auctionGracePeriodHours}
                        </div>
                      )}
                    </Form.Group>
                  </Box>
                </div>
              </div>
            </Box>

            {/* Address Section */}
            <Box sx={sectionStyle}>
              <Typography
                className={classes.headText}
                sx={{
                  fontSize: "18px !important",
                  marginBottom: "1.5rem",
                  color: "#34495e",
                  borderBottom: "2px solid #3498db",
                  paddingBottom: "0.5rem",
                }}
              >
                Address Information
              </Typography>

              <div className="row">
                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Street Address *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        required
                        name="streetOne"
                        placeholder="Enter Street Address"
                        disabled={!editProfile}
                        value={streetOne || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Street Address Line 2
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="streetTwo"
                        placeholder="Enter Address Line 2 (Optional)"
                        disabled={!editProfile}
                        value={streetTwo || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        City *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        required
                        placeholder="Enter City"
                        disabled={!editProfile}
                        name="city"
                        value={city || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Postal/Zip Code *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        required
                        placeholder="Enter Postal/Zip Code"
                        disabled={!editProfile}
                        name="postalCode"
                        value={postalCode || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Country *
                      </Form.Label>
                      <Form.Select
                        aria-label="Select Country"
                        className={classes.input}
                        name="country"
                        onChange={handleChangeSeller}
                        required={true}
                        value={country || ""}
                        disabled={!editProfile}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      >
                        <option value="">Select Country</option>
                        {countriesList &&
                          countriesList.map((countryItem, index) => (
                            <option value={countryItem.id} key={index}>
                              {countryItem.name}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        State *
                      </Form.Label>
                      <Form.Select
                        aria-label="Select State"
                        className={classes.input}
                        name="state"
                        onChange={handleChangeSeller}
                        required={true}
                        value={state || ""}
                        disabled={!editProfile}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      >
                        <option value="">Select State</option>
                        {stateList &&
                          stateList.map((stateItem, index) => (
                            <option key={index} value={stateItem.id}>
                              {stateItem.name}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Box>
                </div>
              </div>
            </Box>

            {/* Representative Information Section */}
            <Box sx={sectionStyle}>
              <Typography
                className={classes.headText}
                sx={{
                  fontSize: "18px !important",
                  marginBottom: "1.5rem",
                  color: "#34495e",
                  borderBottom: "2px solid #3498db",
                  paddingBottom: "0.5rem",
                }}
              >
                Company Representative Information
              </Typography>

              <div className="row">
                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        First Name *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="firstName"
                        placeholder="Enter First Name"
                        required
                        disabled={!editProfile}
                        value={firstName || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                      {errors.firstName && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {errors.firstName}
                        </div>
                      )}
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Last Name *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="lastName"
                        placeholder="Enter Last Name"
                        required
                        disabled={!editProfile}
                        value={lastName || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                      {errors.lastName && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {errors.lastName}
                        </div>
                      )}
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Title/Position *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="text"
                        name="title"
                        placeholder="Enter Job Title"
                        required
                        disabled={!editProfile}
                        value={title || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Email Address *
                      </Form.Label>
                      <Form.Control
                        className={classes.input}
                        type="email"
                        name="email"
                        placeholder="Enter Email Address"
                        required
                        disabled={!editProfile}
                        value={email || ""}
                        onChange={handleChangeSeller}
                        style={{
                          backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "0.75rem",
                        }}
                      />
                      {errors.email && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {errors.email}
                        </div>
                      )}
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Contact Number *
                      </Form.Label>
                      <Box sx={{ display: "flex", gap: "0.5rem" }}>
                        <Form.Control
                          style={{
                            width: "20%",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                            padding: "0.75rem",
                          }}
                          className={classes.input}
                          type="text"
                          placeholder="+91"
                          required
                          disabled={true}
                        />
                        <Form.Control
                          className={classes.input}
                          type="tel"
                          name="contactNumber"
                          placeholder="Enter Contact Number"
                          required
                          disabled={!editProfile}
                          value={contactNumber || ""}
                          onChange={handleChangeSeller}
                          style={{
                            backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                            padding: "0.75rem",
                          }}
                        />
                      </Box>
                    </Form.Group>
                  </Box>
                </div>

                <div className="col-md-6">
                  <Box sx={inputStyle}>
                    <Form.Group className="mb-3">
                      <Form.Label sx={labelStyle} className={classes.label}>
                        Alternate Contact Number
                      </Form.Label>
                      <Box sx={{ display: "flex", gap: "0.5rem" }}>
                        <Form.Control
                          style={{
                            width: "20%",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                            padding: "0.75rem",
                          }}
                          className={classes.input}
                          type="text"
                          placeholder="+91"
                          disabled={true}
                        />
                        <Form.Control
                          className={classes.input}
                          type="tel"
                          name="alternateContactNumber"
                          placeholder="Enter Alternate Contact Number"
                          disabled={!editProfile}
                          value={alternateContactNumber || ""}
                          onChange={handleChangeSeller}
                          style={{
                            backgroundColor: editProfile ? "#fff" : "#f8f9fa",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                            padding: "0.75rem",
                          }}
                        />
                      </Box>
                    </Form.Group>
                  </Box>
                </div>
              </div>
            </Box>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "0.75rem",
                marginTop: "2rem",
                padding: "1rem",
                borderTop: "1px solid #e9ecef",
              }}
            >
              {editProfile ? (
                <>
                  <Button
                    onClick={() => setEditProfile(false)}
                    variant="outlined"
                    sx={{
                      minWidth: "100px",
                      padding: "0.5rem 1rem",
                      borderRadius: "4px",
                      textTransform: "none",
                      fontSize: "14px",
                      color: "#6c757d",
                      borderColor: "#6c757d",
                      "&:hover": {
                        backgroundColor: "#6c757d",
                        color: "#fff",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      minWidth: "100px",
                      padding: "0.5rem 1rem",
                      borderRadius: "4px",
                      textTransform: "none",
                      fontSize: "14px",
                      backgroundColor: "#2D55EB",
                      "&:hover": {
                        backgroundColor: "#1E3DD1",
                      },
                    }}
                  >
                    Save Changes
                  </Button>
                </>
              ) : (
                <Button
                  onClick={() => setEditProfile(true)}
                  variant="contained"
                  sx={{
                    minWidth: "100px",
                    padding: "0.5rem 1rem",
                    borderRadius: "4px",
                    textTransform: "none",
                    fontSize: "14px",
                    backgroundColor: "#2D55EB",
                    "&:hover": {
                      backgroundColor: "#1E3DD1",
                    },
                  }}
                >
                  Edit Profile
                </Button>
              )}
            </Box>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default SellerProfileModal;
